import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import {
  COMMUN_COLUMNS,
  PAGINATION_CURRENT_PAGE,
  PAGINATION_START,
  SUB_TABS_COLUMNS
} from "./constants";
import { DatePicker, Input, Switch, Tooltip } from "antd";
import moment from "moment";
import { Button } from "primereact/button";
import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea';
import './index.scss';
import _ from '../../../i18n';
import lodash from 'lodash';
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { getProspectClients, getClientEntryChannels, saveProspectClients, getProspectClientsEmails, getProspectClientsEmailsFromOutlook } from "../../../api";
import { toast } from "react-toastify";
import { AttachmentIcon, CheckIcon, EditIcon, IconClose, IconPencil, IconTrash } from "../../common/Icons";
import { formatAmount, parsePreference } from "../../../utils";
import AnimatedLoadingIcon from "../../common/Icons/AnimatedLoadingIcon";
import CroissanceFilters from "../Components/CroissanceFilters/CroissanceFilters";
import CreatableSelect from 'react-select/creatable';
import UpdateModal from "./UpdateModal";
import PendingEmailsListModal from "./PendingEmailsListModal";
import ContactHeadsetIcon from "../../common/Icons/ContactHeadsetIcon";
import DisplayEmailModal from "./DisplayEmailModal";
import DeleteModal from "./DeleteModal";


export default function CroissanceClientsProspectsPage({
  changeSelectedYear,
  collaborator,
  preferences
}) {
  const { token, navCommunity, user } = useSelector((state) => state.auth);
  const [bindedSubTabsColumns, setBindedSubTabsColumns] = useState(SUB_TABS_COLUMNS);
  const [showTextModal, setShowTextModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [data, setData] = useState([]);
  const [channelOptions, setChannelOptions] = useState([]);
  const [displayedData, setDisplayedData] = useState([]);
  const [totalDataCount, setTotalDataCount] = useState(0);
  const [modifiedRows, setModifiedRows] = useState([]);
  const modifiedRowsRef = useRef(modifiedRows);
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [currentPage, setCurrentPage] = useState(PAGINATION_CURRENT_PAGE);
  const [pageStart, setPageStart] = useState(PAGINATION_START);
  const [isSaving, setIsSaving] = useState({
    contact: false,
    rowData: false
  });
  const [totalsData, setTotalsData] = useState([{
    "id": 0,
    "clientId": null,
    "group": null,
    "firstName": null,
    "lastName": null,
    "email": null,
    "phoneNumber": null,
    "observation": null,
    "dueDate": null,
    "revenue": 0
  }]);
  const [showPendingEmailsListModal, setShowPendingEmailsListModal] = useState(false);
  const [selectedEmailToProcess, setSelectedEmailToProcess] = useState(null);

  const [filters, setFilters] = useState({
    keyWord: "",
    clientGroup: [],
    bu: parsePreference(preferences.financial).croissance.allowViewDataBy === 100 &&
      collaborator
        ? [collaborator.bu]
        : [],
    zone: parsePreference(preferences.financial).croissance.allowViewDataBy === 101 &&
      collaborator
        ? collaborator.zoneId
        : null,
    partner:
      parsePreference(preferences.financial).croissance.allowViewDataBy === 11
        ? user?.id
        : null,
    collaborator: [10, 100, 101, 110].includes(
      parsePreference(preferences.financial).croissance.allowViewDataBy
    ) && collaborator
      ? Number(collaborator.id)
      : null,
    role: null,
    pageSize: 50,
    year: new Date().getFullYear().toString(),
    reminderType: null,
  });
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [prospectClientsEmails, setProspectClientsEmails] = useState([]);
  const [showDisplayEmailModal, setShowDisplayEmailModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const getProspectClientsQuery = useQuery(
    ["getProspectClients", token, navCommunity, currentPage, pageStart, filters],
    async () => {
      const allowViewDataBy = parsePreference(
        preferences.financial
      ).croissance.allowViewDataBy;
      if (
        [10, 110].includes(allowViewDataBy) &&
        (!filters || !filters.collaborator)
      ) {
        setIsLoadingData(false);
        setData([]);
        setDisplayedData([]);
        setTotalDataCount(0);
        return [];
      } else if (token && navCommunity) {
        setIsLoadingData(true);
        try {
          const response = await getProspectClients({
            token,
            organizationId: navCommunity.id,
            start: pageStart,
            filters
          });
          const data = response.data.data.items;
          const totals = response.data.data.totals;

          setData(data);
          setDisplayedData(data);
          setTotalDataCount(response.data.data.totalCount);
          setTotalsData(prevState => {
            const newVal = {...prevState[0], ...totals};
            return [newVal];
          });
        } catch (e) {
          console.error("Error while fetching prospect clients", {e})
          return null;
        } finally {
          setIsLoadingData(false);
        }
      }
    }
  );

  const getClientEntryChannelsQuery = useQuery(
    ["getClientEntryChannels", token, navCommunity],
    async () => {
      const allowViewDataBy = parsePreference(
        preferences.financial
      ).croissance.allowViewDataBy;
      if (
        [10, 110].includes(allowViewDataBy) &&
        (!filters || !filters.collaborator)
      ) {
        return [];
      } else if (token && navCommunity) {
        try {
          const response = await getClientEntryChannels({
            token,
            organizationId: navCommunity.id
          });

          const data = response.data.data
            .map(it => ({
              value: it.id,
              label: it.label
            }));

          setChannelOptions(data);
        } catch (e) {
          console.error("Error while fetching canals", {e})
        }
      }
    }
  );

  const getProspectClientsEmailsQuery = useQuery(
    ["getProspectClientsEmails", token, navCommunity],
    async () => {
      try {
        const response = await getProspectClientsEmails({
          token,
          organizationId: navCommunity.id
        });
        const data = response.data.data;

        setProspectClientsEmails(data);

      } catch (e) {
        console.error("Error while fetching prospect clients emails", {e})
        return null;
      } finally {
        setIsLoadingData(false);
      }
    }
  );


  const getProspectClientsEmailsFromOutlookQuery = useQuery(
    ["getProspectClientsEmailsFromOutlook", token, navCommunity],
    async () => {
      try {
        await getProspectClientsEmailsFromOutlook({
          token,
          organizationId: navCommunity.id
        });
        // const data = response.data.data;

        // setProspectClientsEmails(data);

      } catch (e) {
        console.error("Error while fetching prospect clients emails from Outlook.", {e})
        return null;
      } finally {
        setIsLoadingData(false);
      }
    }
  );

  useEffect(() => {
    // bind body templates to columns
    const BINDED_SUB_TABS_COLUMNS = {};

    BINDED_SUB_TABS_COLUMNS.admin = SUB_TABS_COLUMNS.admin.map((col) => {
      if (col.field === 'id') {
        col.body = idColumnBodyTemplate;
      } else if (col.field === 'clientName') {
        col.body = clientNameColumnBodyTemplate;
      } else if (col.field === 'channel') {
        col.body = channelColumnBodyTemplate;
      }else if (col.field === 'conversion') {
        col.body = checkUncheckColumnBodyTemplate;
      } else if (col.field === 'revenue') {
        col.body = amountColumnBodyTemplate;
      } else if (col.field === 'dueDate') {
        col.body = dateColumnBodyTemplate;
      } else if (col.field === 'attachments') {
        col.body = attachmentsColumnBodyTemplate;
      } else if (col.field === 'contact') {
        col.body = contactColumnBodyTemplate;
      } else if (['phoneNumber', 'email'].includes(col.field)) {
        col.body = textColumnBodyTemplate;
      } else if (col.field === 'observation') {
        col.body = multiLineTextColumnBodyTemplate;
      } else if (col.field === 'actions') {
        col.body = actionsColumnBodyTemplate;
      }
      return col;
    });

    setBindedSubTabsColumns(BINDED_SUB_TABS_COLUMNS);
  }, [selectedRow, channelOptions]);

  useEffect(() => {
    modifiedRowsRef.current = modifiedRows;
  }, [modifiedRows]);

  const renderSelectedColumns = () => {
    return COMMUN_COLUMNS;
  }

  const dateColumnBodyTemplate = (rowData, args) => {
    if (rowData.id === 0) return '--';

    if (!rowData[args.field]) return '--';

    return rowData[args.field].date ?? moment(rowData[args.field]).format("DD/MM/YY");
  }

  const idColumnBodyTemplate = (rowData, args) => {
    if (rowData.id === 0) return (<span>-</span>);

    return (<span>{args.rowIndex}</span>);
  }

  const clientNameColumnBodyTemplate = (rowData) => {
    if (rowData.id === 0) return (<span className="total-title">Total</span>);

    let fullName = rowData.lastName;
    if (rowData.firstName) {
      fullName = rowData.firstName + ' ' + fullName;
    }

    const clientGroup = rowData.group;
    const clientErpId = rowData.clientErpId;

    return (
      <div className="client-name-cell">
        <div className="client-name-cell-data">
          <span className="client-name-text">{fullName}</span>
          <div className="client-name-info">
            Groupe: {clientGroup}
          </div>
          {!!clientErpId && (
            <div className="client-name-ids">
              <p>ERP ID : {clientErpId}</p>
            </div>
          )}
        </div>
      </div>
    )
  }

  const rdvColumnBodyTemplate = (rowData, args) => {
    if (rowData.id === 0) return (<span>--</span>);

    if (rowData.rdv && rowData.id != selectedRow?.id) {
      const [year, month, day] = rowData.rdv.split("-");
      const date = new Date(year, month - 1, day);

      return (
        <div className="cell-input-field rdv-input-field">
          <Input
            className="input"
            value={moment(date, "YYYY-MM-DD").format("DD/MM")}
            name={args.field}
            disabled={true}
          />
          <span className="edit-icon">
            <IconPencil
              size={12}
              fill="#707f92"
              onClick={() => {
                setSelectedRow(rowData);
              }}
            />
          </span>
        </div>
      );
    }

    let date = null
    const keys = args.field.split('.');
    const hasValue = keys.reduce((obj, key) => obj && obj[key], rowData) &&
    keys.reduce((obj, key) => obj && obj[key], rowData) !== 'x';

    if (hasValue) {
      const [year, month, day] = rowData.rdv.split("-");
      date = new Date(year, month - 1, day);
    }

    return (
      <DatePicker
        value={!hasValue ? null : moment(date, "DD/MM")}
        placeholder="Selectionner"
        onChange={(date) => {
          const year = date._d.getFullYear();
          const month = date._d.getMonth() + 1;
          const day = date._d.getDate();
          handleRowModification(rowData, 'rdv', `${year}-${month}-${day}`);
        }}
        format={"DD/MM"}
        picker="day"
        className="cell-datepicker-input"
      />
    )
  }

  const switchColumnsBodyTemplate = (rowData, args) => {
    if (rowData.id === 0) return (<span>--</span>);

    let classes = 'cell-switch-input';
    const keys = args.field.split('.');
    const isChecked = keys.reduce((obj, key) => obj && obj[key], rowData) === true || keys.reduce((obj, key) => obj && obj[key], rowData) === 'x';

    if (isChecked) {
      classes += ' cell-switch-input-checked';
    }

    return (
      <Switch
        size="small"
        checked={isChecked}
        className={classes}
        onChange={(checked) => {
          handleRowModification(rowData, args.field, checked);
        }}
      />
    )
  }

  const inputFieldColumnBodyTemplate = (rowData, args) => {
    if (rowData.id === 0) return (<span>--</span>);
    const fieldValue = rowData[args.field]

    return (
      <div className="cell-input-field">
        <Input
          className="input"
          value={fieldValue}
          name={args.field}
          onChange={(e) => {
            handleRowModification(rowData, args.field, e.target.value);
          }}
        />
      </div>
    )
  }

  const channelColumnBodyTemplate = (rowData, args) => {
    if (rowData.id === 0) return '--';
    const value = rowData?.channel?.id;
    const channelName = rowData?.channel?.label;

    // return (<span>{channelName}</span>);

    return (
      <CreatableSelect
        closeMenuOnSelect
        placeholder="Sélect."
        options={channelOptions}
        value={channelOptions.find(it => it.value === value) || null}
        styles={{
          control: (provided) => ({
            ...provided,
            minHeight: '30px',
            height: '30px',
            width: '100px',
            fontSize: '12px',
          }),
          valueContainer: (provided) => ({
            ...provided,
            height: '30px',
            padding: '0 6px',
          }),
          input: (provided) => ({
            ...provided,
            margin: '0px',
          }),
          indicatorSeparator: () => ({
            display: 'none',
          }),
          indicatorsContainer: (provided) => ({
            ...provided,
            height: '30px',
          }),
          option: (provided) => ({
            ...provided,
            fontSize: '12px',
            padding: '6px 10px',
          }),
        }}
        onChange={(newValue) =>
          handleRowModification(rowData, args.field, newValue?.value || null)
        }
        onCreateOption={(inputValue) => {
          const newValue = { value: inputValue, label: inputValue };
          handleRowModification(rowData, args.field, inputValue);
        }}
        // isClearable
        isSearchable
      />
    );
  }

  const checkUncheckColumnBodyTemplate = (rowData, args) => {
    if (rowData.id === 0) {
      switch(args.field) {
        case "conversion": return (<span>{rowData.conversion}</span>);
        default: return (<span>--</span>);
      }
    }

    if (args.field === 'conversion') {
      if (rowData.clientId) {
        return <div className="centered-cell">
          <CheckIcon width="20" height="12" fill="#15B392" />
        </div>
      } else {
        return <div className="centered-cell">
          <IconClose size="11" fill="#C7253E" />
        </div>
      }
    }

    if (rowData[args.field]) {
      return <div className="centered-cell">
        <CheckIcon width="20" height="12" fill="#15B392" />
      </div>
    } else {
      return <div className="centered-cell">
        <IconClose size="11" fill="#C7253E" />
      </div>
    }
  };

  const amountColumnBodyTemplate = (rowData, args) => {
    return (<div>{formatAmount(rowData[args.field])}</div>);
  };

  const textColumnBodyTemplate = (rowData, args) => {
    if (rowData.id === 0) {
      return (<span>--</span>);
    }

    if (lodash.isEmpty(rowData[args.field])) {
      return (<span>--</span>);
    }

    return (<div className="cell_text">{rowData[args.field]}</div>);
  };

  const multiLineTextColumnBodyTemplate = (rowData, args) => {
    if (rowData.id === 0) {
      return (<span>--</span>);
    }

    if (lodash.isEmpty(rowData[args.field])) {
      return (<span>--</span>);
    }

    return (
      <div className="cell-multiline-text">
        {rowData[args.field]}
      </div>
    );
  }

  const attachmentsColumnBodyTemplate = (rowData) => {
    if (rowData.id === 0 || !rowData.attachment) return '--';

    return (
      <span
        className="prospects-attachment-icon"
        onClick={() => {
          setSelectedRow(rowData);
          setShowDisplayEmailModal(true);
        }}
      >
        <AttachmentIcon size="16" />
      </span>
    );
  };

  const contactColumnBodyTemplate = (rowData) => {
    if (rowData.id === 0) return (<span>--</span>);

    return (
      <div className="edit-texts-icons">
        <Tooltip title="Contact">
          <span
            className="display-info-button"
            onClick={() => handleShowTextModal(true, rowData)}
            style={{
              backgroundColor: rowData.contact && rowData.contact?.note?.trim() !== '' ? "#E3F9F5" : "#FFFFFF",
              borderColor: rowData.contact && rowData.contact?.note?.trim() !== '' ? "#02AF8E" : "#3C4E64"
            }}
          >
            <ContactHeadsetIcon
              size={18}
              color={rowData.contact && rowData.contact?.note?.trim() !== '' ? "#02AF8E" : "#3C4E64"}
            />
          </span>
        </Tooltip>
      </div>
    );
  };

  const actionsColumnBodyTemplate = (rowData) => {
    if (rowData.id === 0) return '--';

    return (
      <div className="prospects-actions-icons">
        <span
          className="action-icon-container"
          onClick={() => {
            setSelectedRow(rowData);
            setShowUpdateModal(true);
          }}
        >
          <EditIcon fill="orange" size={15}  />
        </span>
        <span
          className="action-icon-container"
          onClick={() => {
            setSelectedRow(rowData);
            setShowDeleteModal(true);
           }}
        >
          <IconTrash color="red" size={15} />
        </span>
      </div>
    );
  };

  const handleShowTextModal = (isVisible, rowData) => {
    if (rowData) {
      setSelectedRow(rowData);
    } else {
      setSelectedRow(null);
    }
    setShowTextModal(isVisible);
  };

  const handleRowModification = (rowData, modifiedPropertyName, modifiedPropertyValue) => {
    const keys = modifiedPropertyName.split('.');
    const updatedRowData = {
      ...rowData,
      [modifiedPropertyName]: modifiedPropertyValue
    };

    // Set the new value in the cloned rowData
    setValue({ ...rowData }, keys, modifiedPropertyValue);

    // Update the modifiedRows state

    setModifiedRows(prevState => {
      // Check if the row already exists in modifiedRows
      const modifiedRowIndex = prevState.findIndex(i => i.id === rowData.id);

      if (modifiedRowIndex > -1) {
        // Update existing modified row
        const updatedModifiedRows = [...prevState];
        updatedModifiedRows[modifiedRowIndex] = { ...updatedModifiedRows[modifiedRowIndex], ...updatedRowData };
        return updatedModifiedRows;
      } else {
        // Add new modified row
        return [...prevState, updatedRowData];
      }
    });

    // Update the displayedData state
    setDisplayedData(prevState =>
      prevState.map(i =>
        i.id === rowData.id ? { ...rowData, [modifiedPropertyName]: modifiedPropertyValue } : i
      )
    );
  };

  const setValue = (obj, keys, value) => {
    keys.reduce((accumulator, key, index) => {
      // If we're at the last key, set the value
      if (index === keys.length - 1) {
        accumulator[key] = value;
      } else {
        // If the key doesn't exist, create an empty object
        if (!accumulator[key]) {
          accumulator[key] = {};
        }
        return accumulator[key]; // Move to the next nested object
      }
      return accumulator;
    }, obj);
  };

  const handleSaveModifiedRows = () => {
    setIsSaving(prevState => ({...prevState, rowData: true}));

    saveProspectClients({token, organizationId: navCommunity.id, items: modifiedRows}).then((res) => {
      if (res.status === 200) {
        setModifiedRows([]);
        setSelectedRow(null);
        toast.success("Les données ont été enregistrées avec succès");
        getProspectClientsQuery.refetch();
        getClientEntryChannelsQuery.refetch();
      } else {
        toast.error("Une erreur est survenue lors de l'enregistrement des données");
      }
    }).catch(e => {
      toast.error("Une erreur est survenue lors de l'enregistrement des données");
      console.error("Error saving data : ", e);
    }).finally(() => {
      setIsSaving(prevState => ({...prevState, rowData: false}));
    });
  }

  const handleSaveContactData = () => {
    let {
      id,
      contact
    } = selectedRow;

    if (contact?.isDone) {
      contact = {
        ...contact,
        isDone: contact.isDone ? 1 : 0
      };
    }

    setIsSaving(prevState => ({...prevState, contact: true}));
    saveProspectClients({
      token,
      organizationId: navCommunity.id,
      items: [{
        id,
        contact
      }]
    }).then((res) => {
      if (res.status === 200) {
        setSelectedRow(null);
        toast.success("Contact enregistré avec succès.");
        getProspectClientsQuery.refetch();
        getProspectClientsEmailsQuery.refetch();
      } else {
        toast.error("Échec de l'enregistrement de contact. Veuillez réessayer.");
      }
    }).catch(e => {
      toast.error("Échec de l'enregistrement de contact. Veuillez réessayer.");
      console.error("Error saving contact : ", e);
    }).finally(() => {
      setIsSaving(prevState => ({...prevState, contact: false}));
    });
  }

  useEffect(() => {
    setCurrentPage(0);
    setPageStart(0);
  }, [filters.pageSize]);

  useEffect(() => {
    changeSelectedYear(filters.year);
  }, [filters.year]);

  return (
    <div className="clients-prospects-container">
       <div className="datatable-header">
        <div className="datatable-header-row">
          <div className="filters" style={{display: "flex", gap: "8px"}}>
            <CroissanceFilters
              filterFormIsVisible={false}
              filter={filters}
              nbResult={totalDataCount}
              updateFilter={setFilters}
              fetching={getProspectClientsQuery.isFetching}
              collaborator={collaborator}
              preferences={preferences}
            />
          </div>
        </div>
        <div className="datatable-header-row">
          <p className="data-count">
            <p>Nombre de clients: <span>{totalDataCount}</span></p>
          </p>
          <div className="add-client-section">
            <p
              className="pending-emails-text"
              onClick={() => setShowPendingEmailsListModal(true)}
            >
              E-mails en attente de traitement (<span>{prospectClientsEmails.filter(it => !it.prospectClientId).length}</span>)
            </p>
            <button
              className="add-client-button"
              onClick={() => setShowUpdateModal(true)}
            >
              Ajouter un client
            </button>
          </div>
        </div>
      </div>

      <DataTable
        value={displayedData}
        frozenValue={totalsData}
        lazy
        paginator
        totalRecords={totalDataCount}
        first={currentPage * filters.pageSize + 1}
        rows={filters.pageSize}
        onPage={(e) => {
          setCurrentPage(e.page);
          setPageStart(e.page * filters.pageSize);
        }}
        scrollable
        tableClassName="clients-prospects-datatable"
        loading={isLoadingData}
        loadingIcon={
          <div className="ripple_loading" style={{alignItems: 'center'}}>
            <img src={"/img/Ripple-1s-150px.svg"} alt="" width={80} height={80} />
          </div>
        }
      >
        {
          renderSelectedColumns().map(col => (
            <Column
              className="datatable-column"
              key={col.field}
              field={col.field}
              header={col.header}
              style={{width: col.style?.width ?? 'auto'}}
              sortable={col.sortable ?? false}
              body={col.body ?? null}
              alignHeader={col?.alignHeader ?? 'left'}
              resizeable={col?.resizeable ?? false}
              align={col?.align ?? 'center'}
            />
          ))
        }
      </DataTable>

      {/* save/cancel buttons */}
      {modifiedRows.length > 0 && (
        <div className="action-buttons">
          <Button
            label="Annuler"
            severity="secondary"
            size="small"
            onClick={() => {
              setModifiedRows([]);
              setDisplayedData(lodash.cloneDeep(data));
            }}
            disabled={isSaving.rowData}
          />
          <Button
            size="small"
            label={
              isSaving.rowData ? (
                <AnimatedLoadingIcon color="#ffffff" />
              ) : 'Enregistrer'
            }
            disabled={isSaving.rowData}
            severity="success"
            onClick={handleSaveModifiedRows}
          />
        </div>
      )}

      {/* contact modal dialog */}
      {showTextModal && selectedRow && (
        <Dialog
          visible={showTextModal && selectedRow}
          onHide={() => handleShowTextModal(false)}
          className="text-modal-dialog"
          header="Contact"
          footer={
            <div>
              <Button
                size="small"
                severity="success"
                onClick={handleSaveContactData}
                disabled={isSaving.contact}
              >
                {
                  isSaving.contact ? (
                    <AnimatedLoadingIcon color="#ffffff" />
                  ):
                  'Enregistrer'
                }
              </Button>
            </div>
          }
        >
          <div className="modal-check-stars">
            <label style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <input
                type="checkbox"
                checked={selectedRow?.contact?.isDone ?? false}
                onChange={(e) => {
                  const isChecked = e.target.checked;
                  setSelectedRow(prevState => ({
                    ...prevState,
                    contact: {
                      ...prevState.contact,
                      isDone: isChecked ? 1 : 0
                    }
                  }));
                }}
              />
              Appel / Rendez-vous
            </label>

            <div className="star-rating">
              <span className="rating-label">Insatisfait</span>
              <div className="stars">
                {[1, 2, 3, 4, 5].map((star) => (
                  <img
                    key={star}
                    src={
                      star <= (selectedRow?.contact?.rating || 0)
                      ? "/img/icon/star.svg"
                      : "/img/icon/light_star.svg"
                    }
                    alt={`Star ${star}`}
                    onClick={() => {
                      setSelectedRow(prevState => ({
                        ...prevState,
                        contact: {
                          ...prevState.contact,
                          rating: star
                        }
                      }));
                    }}
                    style={{ cursor: 'pointer', width: '16px', height: '16px' }}
                  />
                ))}
              </div>
              <span className="rating-label">Ravi</span>
            </div>
          </div>

          <span className="p-float-label" style={{marginTop: '20px'}}>
            <InputTextarea
              id="contact"
              className="textarea"
              rows={5}
              value={selectedRow?.contact?.note}
              disabled={isSaving.contact}
              onChange={(e) => {
                const value = e.target.value;
                setSelectedRow(prevState => ({
                    ...prevState,
                    contact: {
                      ...prevState.contact,
                      note: value
                    }
                  }));
              }}
            />
            <label htmlFor="contact">Contact</label>
          </span>
        </Dialog>
      )}

      {showUpdateModal && (
        <UpdateModal
          isOpen={showUpdateModal}
          setIsOpen={(isOpen) => {
            if (!isOpen) {
              setSelectedEmailToProcess(null);
              setSelectedRow(null);
            }
            setShowUpdateModal(isOpen);

            getProspectClientsQuery.refetch();
            getProspectClientsEmailsQuery.refetch();
          }}
          clientData={selectedRow}
          emailData={selectedEmailToProcess}
        />
      )}

      {showPendingEmailsListModal && (
        <PendingEmailsListModal
          isOpen={showPendingEmailsListModal}
          setIsOpen={(isOpen) => setShowPendingEmailsListModal(isOpen)}
          data={prospectClientsEmails.filter(it => !it.prospectClientId)}
          setData={setProspectClientsEmails}
          setSelectedEmailToProcess={(emailData) => {
            setSelectedEmailToProcess(emailData);
            setShowUpdateModal(true);
            setShowPendingEmailsListModal(false);
          }}
        />
      )}

      {showDisplayEmailModal && (
        <DisplayEmailModal
          isOpen={showDisplayEmailModal}
          setIsOpen={(isOpen) => {
            if (!isOpen) setSelectedRow(null);

            setShowDisplayEmailModal(isOpen)
          }}
          emailData={selectedRow?.attachment}
        />
      )}

      {showDeleteModal && (
        <DeleteModal
          isOpen={showDeleteModal}
          setIsOpen={(isOpen) => {
            if (!isOpen) setSelectedRow(null);

            setShowDeleteModal(isOpen);

            getProspectClientsQuery.refetch();
            getProspectClientsEmailsQuery.refetch();
          }}
          data={selectedRow}
        />
      )}
    </div>
  )
}
